import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';

import './style.css';
import { Button } from '@zinc/ui';

@inject('vm')
@observer
class Action extends React.Component {
  static defaultProps = {
    icon: null,
    label: '',
    onClick: () => {}
  };

  render() {
    let { label, vm } = this.props;

    return (
      <Button
        variant="outline"
        className="action-base"
        size="small"
        disabled={vm.loading}
        onClick={this.onClick}
        color={this.props.color || 'neutral'}
      >
        {label}
      </Button>
    );
  }

  @action.bound
  onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.onClick();
  }
}

export default Action;
